module.exports = __webpack_public_path__ + "static/img/senlin_2.ae8b9f46.png";